"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnswerFieldType = void 0;
// eslint-disable-next-line no-shadow
var AnswerFieldType;
(function (AnswerFieldType) {
    AnswerFieldType["ANSWER_CHECK"] = "answerCheck";
    AnswerFieldType["ANSWER_NUMBER"] = "answerNumber";
    AnswerFieldType["ANSWER_RATING"] = "answerRating";
    AnswerFieldType["ANSWER_LIST"] = "answerList";
    AnswerFieldType["ANSWER_TEXT"] = "answerText";
    AnswerFieldType["ANSWER_DATETIME"] = "answerDateTime";
    AnswerFieldType["ANSWER_PHOTO"] = "answerPhoto";
    AnswerFieldType["ANSWER_SIGNATURE"] = "answerSignature";
    AnswerFieldType["ANSWER_SPT"] = "answerSPT";
})(AnswerFieldType = exports.AnswerFieldType || (exports.AnswerFieldType = {}));
exports.default = AnswerFieldType;
